import Caption from "../Caption";

function UploadedVideoLabel(props) {
  /** Label to show the name of an already uploaded video. */
  return <Caption>{props.children}</Caption>;
}

export default UploadedVideoLabel;
